// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'  //导入axios
import {
  Button,Slider,Loading
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
import {
  MessageBox,
  Toast
} from 'mint-ui'
import global from '@/components/Global.js'
import http from '@/util/http.js'
import 'mint-ui/lib/style.css';

Vue.prototype.$toast = Toast;
Vue.config.productionTip = false
//将axios挂载到原型上
Vue.prototype.$axios = axios;
Vue.use(Button)
Vue.use(Slider)
Vue.use(Loading)
Vue.prototype.$global = global;
Vue.prototype.$http = http;

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js